<!--  -->
<template>
  <div class=''>
    <HeadView :title="headTitle"
              :content="headContent"
              :imgPath="headImgPath" />
    <div class="actuate__content--wrap">
      <div class="actuate__content__item--wrap"
           v-for="(item,index) in actuateData"
           :key="index">
        <div class="iconfont"
             :class="{'icon-kehuduan':item.type == 'khd','icon-qudong':item.type == 'qd'}"
             style="font-size: 32px;"></div>
        <div class="actuate__item__msg--wrap">
          <span style="color: #333333;font-size: 24px;font-weight: bold;">{{ item.title }}</span>
          <span style="font-size: 16px;color: #999;margin-top: 16px;">{{ item.version }}</span>
          <span style="font-size: 16px;color: #999;">{{ item.support }}</span>
        </div>
        <div class="
               actuate__item__downbtn"
             @click="toDownLoad(item)">
          <div class="iconfont icon-xiazai"
               style="font-size: 16px;color:white;"></div>
          <span style="color: white;margin-left: 4px;">下载</span>
        </div>
      </div>
    </div>
    <foot-view></foot-view>
  </div>
</template>

<script>
import HeadView from '@/components/Head/Head.vue'
export default {
  name: 'ServiceView',
  components: { HeadView },
  data () {
    return {
      headTitle: '驱动下载',
      headContent: '提供资料、文档、驱动下载',
      headImgPath: require('../../images/qdxz.png'),
      actuateData: [
        { title: '信任广州平台-证联客户端', version: '版本：v5.0', support: '支持系统：Win7,Win8,Win10', type: 'khd', path: 'http://www.gdcacloud.com/信任广州平台-证联客户端.exe' },
        { title: '信任广州平台-数字证书驱动', version: '版本：v4.3.3.4', support: '支持系统：Win7,Win8,Win10', type: 'qd', path: 'http://www.gdcacloud.com/信任广州平台-数字证书驱动.exe' }]

    }
  },
  computed: {},
  watch: {},
  // 方法集合
  methods: {
    toDownLoad (item) {
      window.open(item.path)
    }
  },
  created () {

  },
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.actuate__content--wrap {
  min-height: 420px;
  box-sizing: border-box;
  padding: 120px 360px;
  display: flex;
  .actuate__content__item--wrap:not(:first-child) {
    margin-left: 32px;
  }

  .actuate__content__item--wrap {
    cursor: pointer;
    display: flex;
    padding: 42px 50px 0 40px;
    height: 180px;
    width: 584px;
    min-width: 584px;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid rgba(230, 232, 234, 1);
    &:hover {
      background-color: rgba(245, 249, 255, 1);
      .actuate__item__downbtn {
        width: 100px;
        height: 38px;
        background-color: $color-primary;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .actuate__item__msg--wrap {
      margin-left: 27px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
    }
    .actuate__item__downbtn {
      display: none;
    }
  }
}
</style>
